module.exports = __webpack_public_path__ + "img/andriod.ec96dbc7.png";